/**
 * Scout v0 — QA grade badge (P18).
 *
 * Grade is always shown as text inside the badge (never state-by-color-alone).
 * A/B (usable) → green (primary), C/D (review) → amber (warning).
 */

import type { QaGrade } from '@/types/scout';

const GRADE_BADGE_CLASS: Record<QaGrade, string> = {
  A: 'badge-primary',
  B: 'badge-primary',
  C: 'badge-warning',
  D: 'badge-warning',
};

export function QaGradeBadge({ grade, label }: { grade: QaGrade; label?: string }) {
  return <span className={`badge ${GRADE_BADGE_CLASS[grade] ?? 'badge-secondary'}`}>{label ?? grade}</span>;
}